export default __webpack_public_path__ + "static/media/Bezel_Blue_Orange.5186df91.png";